import React from 'react';
import GLOBALS from '../globals'

import {useDispatch} from 'react-redux'
import ACTIONS from '../actions/types'
import { useHistory } from 'react-router';

const logoutUser = () => {
  if(GLOBALS.history) {

    GLOBALS.removeCookie('auth_token')
    GLOBALS.reduxStore.dispatch({type: ACTIONS.LOGOUT})
    GLOBALS.history.push('/ui/auth')
  }
};

export default logoutUser;
